import * as React from 'react';

import { H8 } from 'src/components/Typography';
import { FormParserContext } from 'src/contexts/form.context';

export function Heading() {
  const { script } = React.useContext(FormParserContext);

  if (!script.placeholder) return <></>;

  return <H8>{script.placeholder}</H8>;
}
